import React from 'react'
import useTheme from './use-theme'

export default function useOnBeforeThemeChange (callback) {
  const theme = useTheme()

  React.useEffect(() => {
    if (typeof callback !== 'function') {
      return
    }

    if (!theme || typeof theme.onBeforeThemeChange !== 'function') {
      return
    }

    const disposer = theme.onBeforeThemeChange(() => {
      return callback()
    })

    return () => {
      disposer()
    }
  }, [theme, callback])
}
